<template>
  <div
    v-if="image"
    class="
      d-flex
      flex-column
      justify-content-center
      align-items-center
      h-100
      mb-3
    "
  >
    <figure class="ui-figure rounded" @click="onImageClick(image)">
      <img
        :src="image.image_sm"
        class="w-100 ui-figure__img__medialibrary rounded"
      />
    </figure>
  </div>
  <div v-else class="loading">
    <CSpinner color="secondary" size="lg" />
  </div>
</template>

<script>
import { Fancybox } from "@fancyapps/ui";

export default {
  data() {
    return {};
  },

  props: {
    image: Object,
  },

  methods: {
    onImageClick(image) {
      new Fancybox([{ src: image.image.img, type: "image" }]);
    },
  },
};
</script>
